/**
 * Prototype topbar `<span class="pill sync">Zoho synced 6:02 am</span>` (Step 10). Live from GET /integrations
 * (money.read only: the caller decides whether to mount it). Its dot and words follow the Zoho row's status, so
 * "not connected", "behind" and "failing" are visible from every screen, not only on Money and Settings.
 */
import { Link } from 'react-router';
import type { IntegrationStatus } from '@amplispot/contracts';
import { syncedAt, useIntegrations } from '../lib/money';

const DOT: Record<IntegrationStatus, string> = {
  connected: 'var(--hot)',
  stale: 'var(--warm)',
  error: 'var(--cold)',
  off: 'var(--mute)',
};

export function ZohoPill() {
  const q = useIntegrations();
  const z = q.data?.data.find((i) => i.integration === 'zoho');
  if (!z) return null; // loading, failed or not listed: the topbar stays quiet; Settings → Integrations says why
  const at = z.last_success_at ? syncedAt(z.last_success_at) : null;
  const text =
    z.status === 'off' ? 'Zoho not connected'
    : z.status === 'error' ? 'Zoho sync failing'
    : z.status === 'stale' ? (at ? `Zoho behind, last ${at}` : 'Zoho behind')
    : at ? `Zoho synced ${at}` : 'Zoho connected';
  return (
    <Link
      className="pill sync"
      to="/settings/integrations"
      title={z.last_error ?? z.cursor_summary ?? undefined}
      style={{ textDecoration: 'none' }}
    >
      <span className="d" style={{ background: DOT[z.status] }} />
      {text}
    </Link>
  );
}
